import Validation from "backbone-validation";
import $ from "jquery";
import cookie from "js-cookie";
import moment from "moment-timezone";

import { ACCOUNT_TYPE } from "lib/constants";

import SetPasswordView from "./password";
import models from "../models/user";
import util from "../util";

import tmpl from "../templates/components";

util.bindValidation();

const SignupView = SetPasswordView.extend({
    template: tmpl.SignUp,

    defaults: {
        showPhone: true,
        showPassword: true,
    },

    ui: {
        companyName: "input[name=company_name]",
        email: "#email",
        emailError: "#email-error",
        firstName: "#first_name",
        firstNameError: "#first-name-error",
        lastName: "#last_name",
        lastNameError: "#last-name-error",
        title: "input[name=title]",

        btnCandidate: ".signup-btn-candidate",
        btnEmployer: ".signup-btn-employer",
        emailLabel: "label[for=email]",
        employerFields: ".signup-form__employer-fields",
        candidateFields: ".signup-form__candidate-fields",
        signupButtonError: ".signup-form-account-type .help-block",
        signupButtons: ".signup-form-buttons",
        standardFieldsContainer: ".signup-form__standard-fields",
    },

    events: {
        "form submit": "onSubmit",
        "click @ui.btnEmployer": "showEmployerForm",
        "click @ui.btnCandidate": "showCandidateForm",
    },

    initialize() {
        this.model = new models.NewUser();
        this.options = {
            ...this.defaults,
            ...this.options,
        };
    },

    serializeData() {
        return {
            showPhone: this.options.showPhone,
            showPassword: this.options.showPassword,
        };
    },

    showEmployerForm() {
        this.ui.btnCandidate.removeClass("signup-btn--selected");
        this.ui.btnEmployer.addClass("signup-btn--selected");
        this.ui.candidateFields.fadeOut(() => this.ui.employerFields.fadeIn());

        this.ui.companyName.prop("required", true);
        this.model.set("type", ACCOUNT_TYPE.HIRING_MANAGER);
    },

    showCandidateForm() {
        this.ui.btnEmployer.removeClass("signup-btn--selected");
        this.ui.btnCandidate.addClass("signup-btn--selected");
        this.ui.employerFields.fadeOut(() => this.ui.candidateFields.fadeIn());

        this.ui.companyName.prop("required", false);
        this.model.set("type", ACCOUNT_TYPE.APPLICANT);
    },

    isCandidate() {
        return this.ui.btnCandidate.hasClass("signup-btn--selected");
    },

    isEmployer() {
        return this.ui.btnEmployer.hasClass("signup-btn--selected");
    },

    setAccountType(accountType) {
        const className = "signup-btn--selected";
        this.ui.btnCandidate.removeClass(className);
        this.ui.btnEmployer.removeClass(className);

        if (accountType === "candidate") {
            this.ui.btnCandidate.addClass(className);
            this.model.set("type", ACCOUNT_TYPE.APPLICANT);
            this.showCandidateForm();
        } else if (accountType === "employer") {
            this.ui.btnEmployer.addClass(className);
            this.model.set("type", ACCOUNT_TYPE.HIRING_MANAGER);
            this.showEmployerForm();
        }
    },

    getData() {
        const data = SetPasswordView.prototype.getData.call(this);

        if (this.ui.firstName.length) {
            data.first_name = this.ui.firstName.val();
        }

        if (this.ui.lastName.length) {
            data.last_name = this.ui.lastName.val();
        }

        const utm = cookie.get("utm");
        if (utm && utm.length > 0) {
            data.utm = utm;
        }

        if (this.isEmployer()) {
            data.title = this.ui.title.val().trim() || null;
            data.company_name = this.ui.companyName.val().trim();
        }

        data.timezone = moment.tz.guess();

        return data;
    },

    submit() {
        if (this.isEmployer()) {
            // employer signup is disabled, and this shouldn't happen anyway
            return null;
        }
        this.setAccountType("candidate");

        const data = this.getData();
        let hasErrors = !this.model.set(data, { validate: true });

        if (this.ui.signupButtons.length && !this.isEmployer() && !this.isCandidate()) {
            this.ui.signupButtonError.show();
            hasErrors = true;
        } else {
            this.ui.signupButtonError.hide();
        }

        if (hasErrors) {
            return null;
        }

        const deferred = new $.Deferred();
        const self = this;

        this.ui.passwordBtn.disable().addClass("loading");

        this.model.save(null, {
            success(model, response) {
                self.onSuccess(response);
                deferred.resolve(response);
            },
            error(model, response) {
                self.onError(response);
                deferred.reject(response);

                self.ui.passwordBtn.enable().removeClass("loading");
            },
        });

        return deferred.promise();
    },

    showError(msg, msgLower) {
        /* eslint-disable prefer-rest-params */
        SetPasswordView.prototype.showError.apply(this, arguments);
        /* eslint-enable */

        if (msgLower.indexOf("first name") > -1) {
            this.ui.firstNameError.addClass("help-block").text(msg);
        }
        if (msgLower.indexOf("last name") > -1) {
            this.ui.lastNameError.addClass("help-block").text(msg);
        }
    },

    onRender() {
        SetPasswordView.prototype.onRender.call(this);

        Validation.bind(this);

        if (this.options.accountType) {
            this.model.set("type", this.options.accountType);
            this.setAccountType(
                this.options.accountType === ACCOUNT_TYPE.APPLICANT ? "candidate" : "employer",
            );
        } else if (this.isEmployer()) {
            this.model.set("type", ACCOUNT_TYPE.HIRING_MANAGER);
        }

        this.ui.firstName[0].focus();
    },
});

export default SignupView;
